import { Box, Button, IconButton, Slide } from '@mui/material';
import RocketIcon from 'app/components/Icons/RocketIcon';
import {
  actionButton,
  closeButton,
  content,
  description as descriptionSx,
  icon as iconSx,
  iconWrapper,
  modal,
  textBlock,
  title as titleSx,
  wrapper,
} from './NotificationModal.sx';
import useNotificationModal from '../model/useNotificationModal';

/**
 * Popup served by the ib_popup endpoint. Mounted once by the layout, so it
 * follows the user across every page instead of belonging to a single one.
 */
const NotificationModal = () => {
  const { popup, isOpen, iconUrl, buttonText, handleClose, handleAction } = useNotificationModal();

  return (
    <Slide
      direction='up'
      in={isOpen}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 400, exit: 300 }}
    >
      <Box sx={wrapper}>
        <Box sx={modal}>
          <Box sx={content}>
            <Box sx={iconWrapper}>
              {iconUrl ? <Box component='img' src={iconUrl} alt='' sx={iconSx} /> : <RocketIcon />}
            </Box>
            <Box sx={textBlock}>
              <Box sx={titleSx}>{popup?.title ?? ''}</Box>
              <Box sx={descriptionSx}>{popup?.description ?? ''}</Box>
              {popup?.notification_link && (
                <Button sx={actionButton} onClick={handleAction} disableRipple>
                  {buttonText}
                </Button>
              )}
            </Box>
            <IconButton sx={closeButton} onClick={handleClose} disableRipple aria-label='close'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M18 6L6 18M6 6L18 18'
                  stroke='#515555'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Slide>
  );
};

export default NotificationModal;
